import * as sites from 'goodeggs-sites';
import NamedError from 'goodeggs-named-error';

export default __filename;
angular.module(__filename, []).factory(
  'PurchaseOrderProduct',
  ngInject(($http, settings) => ({
    getPurchaseOrderProductByLegacyId: (legacyId) =>
      $http({
        method: 'POST',
        url: `${sites.getUrl('catalog-api', settings)}/graph`,
        data: {
          operationName: 'getPurchaseOrderProductByLegacyId',
          variables: {legacyId},
          query: `\
query getPurchaseOrderProductByLegacyId($legacyId: ID!) {
  purchaseOrderProducts(legacyIds: [$legacyId]) {
    items {
      # TODO get all fields from PurchaseOrderProduct, expunge uses of CatalogProduct
      ownedRelationships {
        hasProducer {
          whereUsedEntity {
            metadata {
              legacyId
            }
            attributes {
              customerFacingName
              slug
            }
          }
        }
      }
    }
  }
}\
`,
        },
      }).then((result) => {
        const graphQLResponse = result.data;
        if (
          graphQLResponse.data == null ||
          graphQLResponse.data.purchaseOrderProducts == null ||
          graphQLResponse.data.purchaseOrderProducts.items == null ||
          graphQLResponse.data.purchaseOrderProducts.items.length > 1
        ) {
          throw new NamedError({
            message: 'Unexpected response from getPurchaseOrderProductByLegacyId query',
            data: {result},
          });
        }
        if (graphQLResponse.data.purchaseOrderProducts.items.length === 0) {
          // Assortment Eng does not intend to migrate all existing legacy Catalog Products to
          // Purchase Order Products, so let's handle a missing POP gracefully.
          return null;
        }
        const graphQLPurchaseOrderProduct = graphQLResponse.data.purchaseOrderProducts.items[0];
        return deserializePurchaseOrderProduct(graphQLPurchaseOrderProduct);
      }),
  })),
);

/* Deserialize a catalog-api GraphQL PurchaseOrderProduct into a purchase-orders-ui
 * PurchaseOrderProduct. TODO(serhalp) define and export a type here when we add flow/ts. */
function deserializePurchaseOrderProduct(graphQLPurchaseOrderProduct) {
  const hasProducerRelationships = graphQLPurchaseOrderProduct.ownedRelationships.hasProducer;
  let producer = null;
  if (hasProducerRelationships.length > 1) {
    throw new NamedError({
      message: 'Unexpected hasProducer relationships on PurchaseOrderProduct',
      data: {graphQLPurchaseOrderProduct},
    });
  }
  // Until the underlying source of truth for this producer field is Riversand, we expect some
  // `PurchaseOrderProduct`s to not return a producer. We record this as `null` for now.
  if (hasProducerRelationships.length === 1) {
    const graphQLProducer = hasProducerRelationships[0].whereUsedEntity;
    producer = {
      id: graphQLProducer.metadata.legacyId,
      name: graphQLProducer.attributes.customerFacingName,
      slug: graphQLProducer.attributes.slug,
    };
  }
  return {
    // TODO add all the other fields we need here instead of using legacy CatalogProduct
    producer,
  };
}
